import 'custom-event-polyfill';
import 'core-js/features/array/find';
import 'core-js/features/array/from';
import 'core-js/features/array/includes';
import 'core-js/features/string/ends-with';
import 'core-js/features/string/starts-with';
import 'regenerator-runtime/runtime';
import Promise from 'promise-polyfill';
import Set from 'es6-set/implement';
import Map from 'es6-map/implement';
if (!window.Promise) {
  window.Promise = Promise;
}
if (!window.Set) {
  window.Set = Set;
}
if (!window.Map) {
  window.Map = Map;
}
